import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import Component from './Component';
export var Animation = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Animation, _Component);

  function Animation(props) {
    return _Component.call(this, _extends({}, props, {
      loop: props.loop === undefined ? props.loop : Number(props.loop)
    })) || this;
  }

  return Animation;
}(Component);